<h2 mat-dialog-title class="dialog-title">Liste des clients consommant ce service</h2>

<div mat-dialog-content>
    <table mat-table [dataSource]="clientSummaries" class="default-table mat-elevation-z1">

        <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef>Clients</th>
            <td mat-cell *matCellDef="let row">{{ row.clientName }}</td>
        </ng-container>

        <ng-container matColumnDef="clientNumber">
            <th mat-header-cell *matHeaderCellDef>Numéro client</th>
            <td mat-cell *matCellDef="let row">{{ row.clientNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="engagementDate">
            <th mat-header-cell *matHeaderCellDef>Date d'engagement</th>
            <td mat-cell *matCellDef="let row">{{ row.engagementDate }}</td>
        </ng-container>

        <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef>Durée</th>
            <td mat-cell *matCellDef="let row">{{ row.duration }}</td>
        </ng-container>

        <ng-container matColumnDef="metrics">
            <th mat-header-cell *matHeaderCellDef>Métrics</th>
            <td mat-cell *matCellDef="let row">{{ row.nbSdas }} SDA</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Statut</th>
            <td mat-cell *matCellDef="let row">{{ row.status }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
                <div class="action-buttons">
                    <button mat-icon-button matTooltip="Voir dans Nexus Centrex"
                        (click)="goToNexusCentrex(row.organizationId)">
                        <mat-icon>home</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Activer/Désactiver module"
                        (click)="toggleAccess(row.organizationId)">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>

<div mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="close()">Fermer</button>
</div>